const history = {
  table: {
    headers: {
      createdBy: 'Von',
      createdAt: 'Erstellt am',
      updatedAt: 'Zuletzt aktualisiert',
      updatedBy: 'Von',
      oldValue: 'Alter Wert',
      newValue: 'Neuer Wert',
      date: 'Datum',
      beforeCopy: {
        regular: 'Kopie',
        sessionId: 'Session-ID kopieren',
      },
      afterCopy: 'Kopiert',
      field: 'Feld',
      description: 'Beschreibung',
      by: 'Von',
    },
  },
};

export default history;
